module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.description) ? _c('markdown', {
    staticClass: "MediaGridItemDescription t-text-sm",
    attrs: {
      "content": _vm.data.description
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e39af7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGridItemDescription.vue
// module id = 768
// module chunks = 1474